export const NAME = 'carloan';
